import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import React from 'react'

const getButton = (plan) => ({
  label: plan.title,
  className: 'link',
  route: `/admin/subscriptions/services/3/plans/${plan.id}`
})

const SignupPagePlanToken = ({ monthly_plan, yearly_plan }) => (
  <div className="token">
    <Button { ...getButton(monthly_plan) } /> (${ monthly_plan.price } / month)<br />
    <Button { ...getButton(yearly_plan) } /> (${ yearly_plan.price } / year)
  </div>
)

SignupPagePlanToken.propTypes = {
  monthly_plan: PropTypes.object,
  yearly_plan: PropTypes.object
}

export default SignupPagePlanToken
